import axios from '@/assets/js/axiosExtend.js'

/**
 * 获取预约事件列表
 * @param {*} params
 */
export const listEvent = (params) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/event/listEventByTR',
  method: 'post',
  data: params,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})
/**
 * 添加预约事件
 * @param {*} params
 */
export const createBooking = (params) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/event/addEvent',
  method: 'post',
  data: params,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

/**
 * 编辑预约事件
 * @param {*} params
 */
export const updateBooking = (params) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/event/update',
  method: 'post',
  data: params,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

/**
 * 删除事件
 * @param {*} id
 */
export const deleteBooking = (id) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/event/delete',
  method: 'post',
  data: { ids: [id] },
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
})

/**
 * 根据时间区间获取事件
 * @param {*} params
 */
export const getEventList = (params) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/extra/page',
  method: 'post',
  data: params
})

/**
 * 批量复制事件
 * @param {*} params
 */
export const duplicateEvent = (params) => axios({
  url: '/gatewayPlayoutUrl/tvu-playout/event/duplicateEvent',
  method: 'post',
  data: params,
  timeout: 120000
})
